import React, { useState,ReactNode,useEffect,useCallback } from 'react';
import Select from 'react-select';
import EarnIcn from "../styles/webroot/images/earned-icn.png";
import PaidIcn from "../styles/webroot/images/paid-icn.png";
import CallIcn from "../styles/webroot/images/call-icn.png";
import MailIcn from "../styles/webroot/images/mail-icn.png";
import UploadError from "../styles/webroot/images/upload-error.png";
import { useDispatch,useSelector } from 'react-redux'
import { getMasterConfigID,getDashboardCount,getDashboardGraphData,getPendingPayment } from '@src/store/slices/common';
import FullPageLoader from '@src/common/FullPageLoader';
import { VictoryChart, VictoryBar, VictoryGroup, VictoryAxis,VictoryTooltip,VictoryLegend } from "victory";
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { getMasterConfig, getDashboardListingID } from '@src/store/slices/insurance';
import {LEAD_LIST_FILTER, STATUS_CODES, COUNTRY_CODE} from '@src/config/constant';
import secureStorage from "@src/config/encrypt";
import * as HELPER from "@src/config/helper";
import DashboardFilterPopup from '@src/common/DashboardFilterPopup';
import CardIcn1 from "../styles/webroot/images/card_in_1.png"
import CardIcn2 from "../styles/webroot/images/card_in_2.png"
import CardIcn3 from "../styles/webroot/images/card_in_3.png"
import CardIcn4 from "../styles/webroot/images/card_in_4.png"
import {leadListFilters} from '@src/store/slices/insurance';
import PaidEarning from './dashboard-id/PaidEarning';
import CreateApplicationSection from './dashboard-id/CreateApplocationSection';
import Support from './dashboard-id/Support';
import { setNewMMVlist } from '@store/slices/commonId';
import { ROLE } from '@src/config/id/constant';
import { useLanguage } from '@src/context/LanguageContext';
import RewardModel from './dashboard-id/RewardModal';

type CustomDateRange = {
  taskSummaryFilters: { from_date: string; to_date: string };
  pendingPaymentFilters: { from_date: string; to_date: string };
  raised_soa?: any; 
};

const graphOption = [
  { value: 'month', label: 'Month View' },
  { value: 'quater', label: 'Quarter View' },
];

interface BucketData {
  label: string;
  count: number;
  type: string;
  screenTitle: string;
  pending_amount?: number;
  amountTitle?: string; //
}

interface EarningSummary {
  comission_earned: string;
  comisssion_paid: string;
}

interface PendingPayment {
  label: string;
  count: number;
  type: string;
  screenTitle: string;
  pending_amount: number;
  amountTitle: string;
}

interface ApiResponse {
  bucket_data: BucketData[];
  earning_summary: EarningSummary;
  pending_payment: PendingPayment;
}

interface GraphData {
  month: string;
  year: string;
  policySold: number;
  actualEarning: number;
  data: { color: string; label: string }[];
}

interface GraphApiResponse {
  average_policy_sold: number;
  average_actual_earning: number;
  graphData: GraphData[];
}

interface SoaOption {
  label: string;
  value: string | number; // If value can be a string or number, adjust accordingly
}

const DashboardID = (props: any) => {

  const navigate = useNavigate();
  const {translations} = useLanguage();
  const [data, setData] = useState<any>(null);
  const [pendingPayment, setPendingPayment] = useState<PendingPayment | null>(null);
  let [loading, setLoading] = useState<boolean>(false)
  const [isCreateAccess , setIsCreateAccess] = useState(false);
  const [selectedOption, setSelectedOption] = useState({
    graphFilter: {
      label: graphOption[0].label,
      value: graphOption[0].value,
    },
    taskSummaryFilters: {
      label: LEAD_LIST_FILTER.taskSummaryFilters[1].label,
      value: LEAD_LIST_FILTER.taskSummaryFilters[1].value,
    },
    pendingPaymentFilters: {
      label: LEAD_LIST_FILTER.pendingPaymentFilters[0].label,
      value: LEAD_LIST_FILTER.pendingPaymentFilters[0].value,
    },
    raised_soa: null
  });
  const [customDateRange, setCustomDateRange] = useState<CustomDateRange>({
    taskSummaryFilters: { from_date: '', to_date: '' },
    pendingPaymentFilters: { from_date: '', to_date: '' },
  });
 
  const [raised_soa, setRaisedSoa] = useState<SoaOption | null>();
  const [searchKey, setSearchKey] = useState('');
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const dispatch: any = useDispatch();
  const [graphData, setGraphData] = useState<GraphApiResponse>({
    average_policy_sold: 0,
    average_actual_earning: 0,
    graphData: [],
  });

  const [filterList, setFilterList] = useState<any>({});
  const [filterType, setFilterType] = useState('');
  const [showFilterPopup, setShowFilterPopup] = useState(false);

  const commonState = useSelector((state: any) => state.common);
  const [masterConfig, setMasterConfig] = useState<any>({});
  const [navName, setNavName] = useState();

  const isCountryId = COUNTRY_CODE ==='id' ? true : false;
  let user_data = secureStorage.getItem("authAgentUserInfo");
  const roleId = user_data?.user_data?.role_id;

  const fetchMasterConfig = useCallback(async () => {
    try {
      const res: any = await dispatch(getMasterConfigID());
      if (res) {
        setMasterConfig(res);
      }
    } catch (error) {
      console.error("Failed to fetch master config:", error);
    }
  }, [dispatch]);

  useEffect(() => {
    if (!commonState?.common || Object.keys(commonState.common).length === 0) {
      fetchMasterConfig();
    } else {
      setMasterConfig(commonState.common);
    }
    dispatch(leadListFilters({}))
  }, [commonState?.common, fetchMasterConfig]);
 
  const DashboardCount = (dashBoardCountRequest: any = {}) => {
    setLoading(true);
    const currentDate = new Date();
    let from_date = '';
    let to_date = '';
    if (Object.keys(dashBoardCountRequest).length === 0) {
      const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
      // If no dates are provided in the request, set default for MTD (Month To Date)
      from_date = firstDayOfMonth.toLocaleDateString('en-CA'); // First day of the current month
      to_date = currentDate.toISOString().split('T')[0]; // Today's date
    } else {
      from_date = dashBoardCountRequest.from_date || '';
      to_date = dashBoardCountRequest.to_date || '';
    }
    const requestPayload = {
      ...dashBoardCountRequest,
    };
    if (from_date) requestPayload.from_date = from_date;
    if (to_date) requestPayload.to_date = to_date;
    // dispatch(getDashboardCount(requestPayload)).then((res: any) => {
    //     setLoading(false)
    //     if (res && res.status === STATUS_CODES['success']) {
    //       setData(res.data);
    //     }
    // }).catch((err: Error) => {
    //     setLoading(false)
    // })
    
    
    let newObj = {
      user_id: user_data.user_data.user_id,
      pe_end_date: requestPayload.to_date,
      ts_end_date: requestPayload.to_date,
      pe_start_date:requestPayload.from_date,
      ts_start_date: requestPayload.from_date
    };
     dispatch(getDashboardListingID(newObj)).then((res: any) => {
      setLoading(false)
          setData(res);  
          setNavName(res?.bucket_data);    
    }).catch((err: Error) => {
        setLoading(false)
    })
  }

  const PendingPaymentCount = (pendingCountRequest: any = {}) => {
    setLoading(true);
    const currentDate = new Date();
    let from_date = '';
    let to_date = '';
    if (Object.keys(pendingCountRequest).length === 0) {
      let currentNewDate = new Date(currentDate); 
      currentNewDate.setDate(currentDate.getDate() + 1);
      from_date = currentNewDate.toISOString().split('T')[0];
      const next7Days = new Date(currentDate);
      next7Days.setDate(currentDate.getDate() + 7);
      to_date = next7Days.toISOString().split('T')[0];
    }else{
      from_date = pendingCountRequest.from_date || '';
      to_date = pendingCountRequest.to_date || '';
    }
    const requestPayload = {
      ...pendingCountRequest
    };
    if (from_date) requestPayload.from_date = from_date;
    if (to_date) requestPayload.to_date = to_date;
    if(pendingCountRequest.raised_soa) requestPayload.raised_soa = pendingCountRequest.raised_soa;
    // dispatch(getPendingPayment(requestPayload)).then((res: any) => {
    //     setLoading(false)
    //     if (res && res.status === STATUS_CODES['success']) {
    //       setPendingPayment(res.data);
    //     }
    // }).catch((err: Error) => {
    //     setLoading(false)
    // })
  }

  const GraphData = (graphRequest: any) => {
    setLoading(true);
    try{
      // getDashboardGraphData(graphRequest).then((res:any) => {
      //   setLoading(false)
      //   if (res && res.data) {
      //     setGraphData(res.data);
      //   }
      // });
    }catch(error){
      setLoading(false)
    }
    
  }


  useEffect(() => {
    DashboardCount();
    PendingPaymentCount();
    secureStorage.removeItem('lead_id');
    secureStorage.removeItem('vehicle_type');
    dispatch(setNewMMVlist({model_id:{},make_id:{},version_id:{}}))
    // eslint-disable-next-line
  } , [])

  useEffect(() => {
    const graphRequest = {
      view_type: selectedOption?.graphFilter?.value || "month"
    }
    GraphData(graphRequest);
  }, [selectedOption.graphFilter]);


  const handleFilterPopup = (filters:any, key:string) => {
    setFilterList(filters);
    setFilterType(key);
    setShowFilterPopup(true);
  }

  const handleFilterPopupClose = () => {
    setShowFilterPopup(false)
  } ;

  const getFilterOption = (type: keyof typeof LEAD_LIST_FILTER, value: string | number) => {
    const filterOptions = LEAD_LIST_FILTER[type];
    return filterOptions?.find((option) => option.value.toString() === value.toString()) || null;
  };

  const applyFilter = (filter:any) => {
    const selectedFilterValue = filter[filterType];
    const updatedOption = getFilterOption(filterType as keyof typeof LEAD_LIST_FILTER, selectedFilterValue);
    if (updatedOption) {
      setSelectedOption((prev) => ({
          ...prev,
          [filterType]: {
              label: updatedOption.label,
              value: updatedOption.value,
          },
      }));
    }
    if ('raised_soa' in filter) {
      const selectedSoa = LEAD_LIST_FILTER.raised_soa.find(option => option.value === filter.raised_soa.toString());
      if (selectedSoa) {
          setRaisedSoa(selectedSoa);
      }
    }
    const filterDates = selectedFilterValue === "cdr"
    ? {
          from_date: filter.from_date || null,
          to_date: filter.to_date || null,
      }
    : HELPER.dateReturn(selectedFilterValue) || { from_date: null, to_date: null };

    if (selectedFilterValue === "cdr") {
      setCustomDateRange((prevState) => ({
          ...prevState,
          [filterType]: {
              from_date: filter.from_date || '',
              to_date: filter.to_date || '',
          },
      }));
    }

    let finalFilter = {
      ...filter,
      ...filterDates,
    };

    const { [filterType]: _, ...rest } = finalFilter;
    finalFilter = rest;

    Object.keys(finalFilter).forEach((key) => {
        if (finalFilter[key] === null || finalFilter[key] === "") {
            delete finalFilter[key];
        }
    });
    if(filterType === "taskSummaryFilters"){
      DashboardCount(finalFilter);
    }else{
      PendingPaymentCount(finalFilter);
    }
  }
  
  const setSearchKeyword = (keyword:any) => {
    setSearchKey(keyword);
  }

  const handleKeyDown = (event:any) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  const handleSearch = () => {
    let resultWithSearchKey: any = {
      searchKey,
    };
    if (selectedOption.taskSummaryFilters?.value === "cdr") {
      const customRange = customDateRange['taskSummaryFilters'];
      resultWithSearchKey = {
        ...customRange,
        ...resultWithSearchKey,
        datetype: selectedOption.taskSummaryFilters.value,
      };
    }else{
      resultWithSearchKey = {
        searchKey,
        datetype: selectedOption.taskSummaryFilters.value,
      };
    }
    const queryString = new URLSearchParams(resultWithSearchKey).toString();
    navigate(`/insurance-list?${queryString}`);
  }

  const handleRedirection = (redirectType:string) => {
    let redirectionParams:any = {};
    // here we get current month date
    const from_date = data?.bucket_data[0].filter_params.from_date;
    const to_date = data?.bucket_data[0].filter_params.to_date;
    
    if(redirectType === data?.bucket_data[0].type || redirectType === data?.bucket_data[1].type || redirectType === data?.bucket_data[2].type){
      if (selectedOption.taskSummaryFilters?.value === "cdr") {
        const getFilterData = customDateRange['taskSummaryFilters'];
        if(searchKey) redirectionParams = { ...getFilterData, searchKey,datetype: selectedOption.taskSummaryFilters.value, };
        else redirectionParams = { ...getFilterData,datetype: selectedOption.taskSummaryFilters.value, };
      }else{
        if(searchKey) redirectionParams = { searchKey,datetype: selectedOption.taskSummaryFilters.value, };
        else redirectionParams = { datetype: selectedOption.taskSummaryFilters.value, };
      }
    }else{

      if (selectedOption.pendingPaymentFilters?.value === "cdr") {
        const getFilterData = customDateRange['pendingPaymentFilters'];
        redirectionParams = { ...getFilterData,datetype: selectedOption.pendingPaymentFilters.value };
        if(searchKey) redirectionParams = { ...redirectionParams, searchKey };
        if(raised_soa) redirectionParams = { ...redirectionParams, raised_soa: raised_soa.value};
      }else{
        redirectionParams = { datetype: selectedOption.pendingPaymentFilters.value };
        if(searchKey) redirectionParams = { ...redirectionParams, searchKey };
        if(raised_soa) redirectionParams = { ...redirectionParams, raised_soa: raised_soa.value};
      }
    }
    if (redirectType == "potential_payment") {
      redirectionParams = { ...redirectionParams, current_nav: redirectType }
    } else {
      redirectionParams = { ...redirectionParams, status_type: redirectType }
    }

    //ADD DATES FOR filteration
    if (from_date) redirectionParams.from_date = from_date;
    if (to_date) redirectionParams.to_date = to_date;

    const queryString = new URLSearchParams(redirectionParams).toString();

    navigate(`/insurance-list?${queryString}`);
  }

  const handleGraphViewChange = (selectedOption: any) => {
    setSelectedOption((prev) => ({
      ...prev,
      graphFilter: {
        label: selectedOption.label,
        value: selectedOption.value,
      },
    }));
    const graphRequest = {
      view_type: selectedOption?.value || "month"
    }
    GraphData(graphRequest);
  };

  const hideErrorPopup = () => {
    setError(false);
    document.body.classList.remove("overflow-hidden");
  };

  const hideSuccessPopup = () => {
    setSuccess(false);
    document.body.classList.remove("overflow-hidden");
  };

  const transformedData = graphData.graphData.map((item) => ({
    x: `${item.month} ${item.year}`,
    policySold: item.policySold,
    actualEarning: item.actualEarning,
  }));

  useEffect(() => {
    const loggedInUser = secureStorage.getItem("authAgentUserInfo");
    if(loggedInUser.user_data.status === 1){
      setIsCreateAccess(true);
    }else{
      setIsCreateAccess(false);
    }
}, []) 

  return (  
    <React.Fragment>
       
      <FullPageLoader show={loading} />
      <DashboardFilterPopup show={showFilterPopup} handleClose={handleFilterPopupClose} filterList={filterList.length ? filterList : []} filterType={filterType} onSuccess={(response: any) => {
        applyFilter(response.applied_filter);
      }}></DashboardFilterPopup>
      <div className="container-fluid">
        <div className="lead-top-heading p-lg-t p-lg-b">
          <h1>{translations?.DASHBOARD?.DASHBOARD}</h1>
          <div className="right-sec-btn search-bar-dashboard">
            <div className="search-bx">
              <div className="material" title={translations?.DASHBOARD?.SEARCH}>
                <input type="text" placeholder={translations?.DASHBOARD?.SEARCH} value={searchKey} aria-label="Search text" onChange={(e) => setSearchKeyword(e.target.value)} onKeyDown={handleKeyDown}/>
                <i className="ic-search"></i>
              </div>
            </div>
            {/* {
              (![ROLE.VP, ROLE.SH].includes(roleId) && isCreateAccess)&& 
              <Link to='/create-insurance-policy' className='m-sm-r'>
                <button className="btn-primary btn-width-auto">
                  <i className="ic-add"></i>
                  {translations?.COMMON_MSG?.CREATE}
                </button>
              </Link>
            } */}
            {/* onClick={showSuccessPopup} */}
            {/* <Link to='/claim-list' className="btn-line btn-width-auto">
              <i className="ic-person"></i>
              Claim
            </Link> */}
          </div>
        </div>
        { ![ROLE.VP, ROLE.SH].includes(roleId) &&
        <CreateApplicationSection masterConfig={masterConfig} setLoading={setLoading}/>
        }
        <div className="row p-lg-t">
          <div className="col-md-9 top-card-left">
            <div className="task-summery-outer bg-white top-card-radius">
              <div className="row">
                <div className="col-md-12">
                  <div className="summery-heading">
                    <h2>{translations?.DASHBOARD?.TASK_SUMMARY}</h2>
                    <div className="task-right-panel task-summery-left-panel">
                    
                      <fieldset className="single-select">
                        <div className="material" onClick={()=> handleFilterPopup(LEAD_LIST_FILTER.taskSummaryFilters, 'taskSummaryFilters')}>
                          <Select
                            value={selectedOption.taskSummaryFilters}
                            options={LEAD_LIST_FILTER.taskSummaryFilters}
                            placeholder="Till Today (All)"
                            className='react-select-opt custom-black-text'
                            classNamePrefix='react-select-opt'
                            isDisabled={true}
                          />
                        </div>
                      </fieldset>
                    </div>
                  </div>
                </div>
                <div className='col-xs-4' onClick={() => handleRedirection(data?.bucket_data[0].type ?? '')}>
                  <div className='summery-card application-submit-card'>
                    <h3>{data?.bucket_data?.[0]?.value}</h3>
                    <span>{data?.bucket_data?.[0]?.screenTitle}</span>
                    <div className="next-arrow-bg">
                      <i className="ic-arrow_forward"></i>
                    </div>
                    <img src={CardIcn1} className="cardicn" />
                  </div>
                </div>
                <div className='col-xs-4' onClick={() => handleRedirection(data?.bucket_data[1].type ?? '')}>
                  <div className='summery-card policies-issued-card'>
                    <h3>{data?.bucket_data?.[1]?.value}</h3>
                    <span>{data?.bucket_data?.[1]?.screenTitle}</span>
                    <div className="next-arrow-bg">
                      <i className="ic-arrow_forward"></i>
                    </div>
                    <img src={CardIcn2} className="cardicn" />
                  </div>
                </div>
                <div className='col-xs-4' onClick={() => handleRedirection(data?.bucket_data[2].type ?? '')}>
                  <div className='summery-card pending-applications-card'>
                    <h3>{data?.bucket_data?.[2]?.value}</h3>
                    <span>{data?.bucket_data?.[2]?.screenTitle}</span>
                    <div className="next-arrow-bg">
                      <i className="ic-arrow_forward"></i>
                    </div>
                    <img src={CardIcn3} className="cardicn" />
                  </div>
                </div>
                
              </div>
            </div>
          </div>
          <div className='col-md-3 top-card-right'>
            <div className="task-summery-outer bg-white">
              <div className="row">
                <div className="col-md-12 w-100">
                  <PaidEarning title="Paid Earning" data={data} api={DashboardCount}/>
                </div>
              </div>
            </div>
          </div>
          <div className={`${[ROLE.BM, ROLE.VP, ROLE.SH].includes(roleId) ? 'col-md-5' : 'col-md-6'} m-lg-t m-100`}>
            <div className="task-summery-outer bg-white earning-compare-graph">
              <div className="row">
                <div className="col-md-">
                  <PaidEarning title="Potential Earning" data={data} handleRedirection={handleRedirection} api={DashboardCount} />  
                </div>
              </div>
            </div>
          </div>
            { [ROLE.BM, ROLE.VP, ROLE.SH].includes(roleId) &&
           <div className='col-md-3 col-xs-12 m-lg-t m-100 agnet-commission-sec'>
            <div className="task-summery-outer bg-white earning-compare-graph">
              <div className="row">
                <div className="col-md-">
                  <PaidEarning title="Agent Commission Change" data={data} handleRedirection={handleRedirection} api={DashboardCount} />  
                </div>
              </div>
            </div>
          </div>
          }

          <Support masterConfig={masterConfig}/>
        </div>

        <div className="model-outer upload-error-popup">
          <Modal show={error} handleClose={hideErrorPopup}>
            <div className="modal-body">
              <div className='upload-error-msg'>
                <img src={UploadError} alt="Upload Error" />
                <p>Some error found in uploaded image. Make sure document/photo should be correct</p>
                <span className='error-txt'> <i className='ic-clearclose'></i> Image size should be under 25 Mb</span>
                <span className='success-txt'> <i className='ic-check'></i> Image should not be blurry</span>
              </div>
            </div>
            <div className='modal-footer m-lg-t'>
              <button className='btn-primary btn-width-100'>Okay</button>
            </div>
          </Modal>
        </div>

        <div className="model-outer upload-success-popup">
          <Modal show={success} handleClose={hideSuccessPopup}>
            <div className="modal-body">
              <div className='upload-success-msg'>
                <div className='check-icn'>
                  <i className='ic-check'></i>
                </div>
                <span className='thanks-txt'>Thank You For Application Submission!</span>
                <div className='id-number'>Your application id is 1234567890</div>
              </div>
            </div>
            <div className='modal-footer m-lg-t'>
              <button className='btn-primary btn-white'>Okay</button>
            </div>
          </Modal>
        </div>

        <RewardModel/>
      </div>
    </React.Fragment>
  );
};

interface ModalProps {
  handleClose: () => void;
  show: boolean;
  children: ReactNode;
}

const Modal: React.FC<ModalProps> = ({ handleClose, show, children }) => {
  const showHideClassName = show ? 'modal display-block' : 'modal display-none';

  return (
    <div className={showHideClassName}>
      <section className='modal-main'>
        {children}
        <button
          onClick={handleClose}
          className="close_icn"
        >
          <i className="ic-clearclose"></i>
        </button>
      </section>
    </div>
  );
};

export default DashboardID;
